import moment from 'moment';
import common from '@/mixins/common';

export default {
  mixins: [common],
  methods: {
    getCompletionStatusText(member) {
      const debug = false;
      let status = '0 of 0 Complete';
      if (member && member.attributes) {
        this.log('getCompletionStatusText', 'member', member, false);
        let numberOfActivities = 0;
        let numberOfCompletedActivities = 0;
        let numberOfInProgress = 0;
        // status = `${member.attributes.number_of_completed_activities} of
        // ${member.attributes.number_of_activities} complete`;
        if (member.attributes.number_of_completed_activities) {
          numberOfCompletedActivities = member.attributes.number_of_completed_activities;
        }
        if (member.attributes.number_of_in_progress_activities) {
          numberOfInProgress = member.attributes.number_of_in_progress_activities;
        }
        if (member.attributes.number_of_activities) {
          numberOfActivities = member.attributes.number_of_activities;
        }
        this.log('getCompletionStatusText', 'numberOfInProgress', numberOfInProgress, debug);
        this.log('getCompletionStatusText', 'numberOfCompletedActivities', numberOfCompletedActivities, debug);
        this.log('getCompletionStatusText', 'numberOfActivities', numberOfActivities, debug);
        status = `${numberOfCompletedActivities} of ${numberOfActivities} Complete`;
      }
      return status;
    },
    formatMemberDate(date) {
      return moment(date).format('MM/DD/YYYY');
    },
    determineOverallStatus(member) {
      let status = '';
      if (this.userOverdueFlag(member)) {
        status = 'Overdue';
      } else if (member.attributes.number_of_activities === member.attributes.number_of_completed_activities) {
        status = 'Completed';
      } else {
        status = 'In-Progress';
      }
      return status;
    },
    userActivitiesCompletedPercentageV2(member) {
      const debug = false;
      let percentage = 0;
      if (member && member.attributes) {
        const completedActivities = member.attributes.number_of_completed_activities;
        const totalActivities = member.attributes.number_of_activities;
        this.log('userActivitiesCompletedPercentageV2', 'completedActivities', completedActivities, debug);
        this.log('userActivitiesCompletedPercentageV2', 'totalActivities', totalActivities, debug);
        percentage = ((completedActivities / totalActivities) * 100).toFixed(0);
        this.log('userActivitiesCompletedPercentageV2', 'percentage', percentage, debug);
      }
      return `${percentage}%`;
    },
    getMemberDueDate(member) {
      let dueDate = '00/00/00';
      if (member && member.attributes) {
        this.log('getMemberDueDate', 'member', member, false);
        // this.log('getMemberDueDate', 'dueDate', dueDate);
        dueDate = moment(member.attributes.activity_due_at).format('MM/DD/YY');
      }
      return dueDate;
    },
    getDueDateFromListOfActivities(activityMembers) {
      let result = null;
      let dueDate = moment();
      if (activityMembers && activityMembers.length > 0) {
        for (let i = 0; i < activityMembers.length; i += 1) {
          const member = activityMembers[i];
          if (member && member.attributes) {
            const memberDueDate = moment(member.attributes.activity_due_at);
            if (dueDate.isBefore(memberDueDate)) {
              dueDate = memberDueDate;
            }
          }
        }
        result = dueDate.format('MM/DD/YY');
      }
      return result;
    },
    userOverdueFlag(member) {
      let result = false;
      if (member && member.attributes && member.attributes.overdue_flag) {
        result = member.attributes.overdue_flag;
      }
      return result;
    },
    userCompletedActivitiesV2(member) {
      if (member) {
        return member.attributes.number_of_completed_activities;
      }
      return 0;
    },
    userTotalActivitiesV2(member) {
      if (member) {
        return member.attributes.number_of_activities;
      }
      return 0;
    },
  },
};
